import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { MOCK_TECH_SPECS } from "../../../data";
import { ManufacturerModelTechSpecRow } from "../../../types";
import { useStyles } from "./styles";

const formatCellValue = (value: string | number | null): string | number => {
  if (value === null || value === "") {
    return "-";
  }

  return value;
};

const DetailsTable = () => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "bodyType",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.BODY_TYPE"),
        align: "center",
        minWidth: 96,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.bodyType)}
          </span>
        ),
      },
      {
        id: "dhType",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.DH_TYPE"),
        align: "center",
        minWidth: 80,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>{formatCellValue(row.dhType)}</span>
        ),
      },
      {
        id: "requiresPlan",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.REQUIRES_PLAN"),
        align: "center",
        minWidth: 110,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.requiresPlan)}
          </span>
        ),
      },
      {
        id: "notes",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.NOTES"),
        align: "center",
        minWidth: 80,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>{formatCellValue(row.notes)}</span>
        ),
      },
      {
        id: "rearAxlesMeasure",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.REAR_AXLES_MEASURE"),
        align: "center",
        minWidth: 120,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.rearAxlesMeasure)}
          </span>
        ),
      },
      {
        id: "frontLoad",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.FRONT_LOAD"),
        align: "center",
        minWidth: 96,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.frontLoad)}
          </span>
        ),
      },
      {
        id: "upperLimit",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.UPPER_LIMIT"),
        align: "center",
        minWidth: 96,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.upperLimit)}
          </span>
        ),
      },
      {
        id: "lowerLimit",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.LOWER_LIMIT"),
        align: "center",
        minWidth: 96,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.lowerLimit)}
          </span>
        ),
      },
      {
        id: "axlesMeasure",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.AXLES_MEASURE"),
        align: "center",
        minWidth: 96,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.axlesMeasure)}
          </span>
        ),
      },
      {
        id: "weight",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.WEIGHT"),
        align: "center",
        minWidth: 72,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>{formatCellValue(row.weight)}</span>
        ),
      },
      {
        id: "classType",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.CLASS_TYPE"),
        align: "center",
        minWidth: 96,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.classType)}
          </span>
        ),
      },
      {
        id: "tire",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.TIRE"),
        align: "center",
        minWidth: 72,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>{formatCellValue(row.tire)}</span>
        ),
      },
      {
        id: "driverCabinType",
        label: t("MANUFACTURER_MODELS.DETAILS.TABLE.DRIVER_CABIN_TYPE"),
        align: "center",
        minWidth: 110,
        format: (row: ManufacturerModelTechSpecRow) => (
          <span className={styles.textCell}>
            {formatCellValue(row.driverCabinType)}
          </span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={MOCK_TECH_SPECS}
        columns={columns}
        scrollClass="custom-scroll-bar"
        serialEnabled={false}
        noDataLabel={t("MANUFACTURER_MODELS.DETAILS.TABLE.EMPTY")}
      />
    </div>
  );
};

export default DetailsTable;
